<p class="py-3">
    The Send Journal Entry feature sends labor related journal entries to
    QuickBooks. Prior to sending journal entries review your Account Posting
    setup to ensure posting accounts have been properly designated.
    <br />
    <br />
    LABOR ACCRUAL Labor entry posted for the selected pay period using the
    pay period end date. If the pay period crosses months, the recommended
    procedure is to follow this up with the Accrual and Reversal step to adjust
    labor into the month it was worked.
    <br />
    <br />
    ACCRUAL/REVERSAL Posts two journal entries (1) a labor accrual entry
    and (2) a reversal of the accrual. The Labor Accrual Date defines the
    maximum date included in the accrual, as well as the JE date. For pay
    periods that cross months, this date defaults to month end.
    <br />
    <br />
    LEAVE ACCRUAL Posts a journal entry for leave accrued during the selected
    pay period. Journal entry is dated using the pay period end date.
    <ng-container *ngIf="externalIntegration">
        <br />
        <br />
        GOVCONPAY PAYROLL Sends payroll journal entries for GovConPay for the selected pay period.
    </ng-container>
</p>
<div class="flex flex-wrap gap-2 mb-2">
    <button pButton pRipple severity="primary" icon="pi pi-send" (click)="SendPayPeriodLabor.emit()" [disabled]="!Filter?.PayPeriodEndDate">
        Labor Accrual
    </button>
    <button pButton pRipple severity="primary" icon="pi pi-send" (click)="SendAccruals.emit()" [disabled]="!(Filter?.PayPeriodEndDate && Filter?.LeaveAccrualDate && Filter?.LaborAccrualDate)">
        Accrual/Reversal
    </button>
    <button pButton pRipple severity="primary" icon="pi pi-send" (click)="SendLeaveAccruals.emit()" [disabled]="!(Filter?.PayPeriodEndDate && Filter?.LeaveAccrualDate)">
        Leave Accrual
    </button>
    <button *ngIf="externalIntegration" pButton pRipple severity="primary" icon="pi pi-send" (click)="SendGovConPayPayroll.emit()" [disabled]="!Filter?.PayPeriodEndDate">
        GovConPay Payroll
    </button>
</div>
<p-message
    severity="info"
    text="To accrue monthly labor, keep date settings and click the Accrue/Reverse button."
></p-message>
